export default __webpack_public_path__ + "static/media/Wopee-Logo.5fb2041d.png";